module.exports = __webpack_public_path__ + "static/media/receta-23.a12f9645.png";